import { Assets } from "assets/Assets";
import React from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, Dim } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  img?: any;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, img }) => {
  return (
    <PageHeaderContainer img={img}>
      <Dim />
      <Container>
        <Title>
          {title}
          <Dot className="text-xxxl">.</Dot>
        </Title>
        {subtitle && (
          <SubTitle className="text-body page-header-subtitle">
            {subtitle}
            <Dot className="text-xxl">.</Dot>
          </SubTitle>
        )}
      </Container>
    </PageHeaderContainer>
  );
};

const PageHeaderContainer = styled.div<{ img: any }>`
  margin-bottom: 20px;
  background-image: ${(props) =>
    props.img
      ? `url(data:${props.img.contentType};base64,${props.img.image});`
      : `url(${Assets.About.storePlovdiv})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 200px;
  position: relative;

  .custom-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media only screen and (${device.laptop}) {
    height: 300px;
  }

  @media only screen and (${device.laptopL}) {
    height: 400px;
  }

  @media only screen and (${device.desktop}) {
    height: 500px;
  }
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;
const Title = styled.h1`
  color: white;
  text-align: center;
  margin-bottom: 0 !important;
`;
const SubTitle = styled(DefaultText)`
  color: white;
`;
const Dot = styled.span`
  color: ${colors.light_blue};
  line-height: 0 !important;
`;

export default PageHeader;
